import { OptionWithLoading } from '../../pages/userManagement/userManagement.type';

export type TableHeader<T> = {
  generateCellContent: (rowItem: T) => number | string | JSX.Element;
  header: string | JSX.Element;
  sortable?: boolean;
  key?: keyof T;
  getCellClassName?: (rowItem: T) => string;
};

export type TableProps<T, Kebabaction extends string = string> = {
  tableHeader: TableHeader<T>[];
  tableData: T[];
  onSelectionChange?: (selectedIds: T[]) => void;
  selectedRows?: T[];
  loading?: boolean;
  onViewDetail?: (row: T, index: number) => void;
  onKebabSelect: (action: Kebabaction, row: T, rowIndex: number) => void;
  loadingMenu:
    | { rowIndex: number; action: Kebabaction }
    | { rowIndex: -1; action: '' };
  getKebabMenuOptions: <T>(
    row: T,
    loadingMenu:
      | { rowIndex: number; action: Kebabaction }
      | { rowIndex: -1; action: '' },
    rowIndex: number,
  ) => OptionWithLoading<Kebabaction>[];
  onShouldCloseKebabMenu?: (action: Kebabaction) => boolean;
  rowKey?: keyof T;
};

export enum SortKey {
  ASC = 'asc',
  DESC = 'desc',
}

export type TableFooterProps = {
  footerText: string;
  displayedCount?: number;
  totalCount?: number;
  unitText: string;
};

export const TooltipLength = 20;
